export default __webpack_public_path__ + "static/media/login-screen-1-2x.04cfb7a0.png";